import styled from "styled-components";
import { palette } from "styled-theme";

const AppWrapper = styled.div`
  .ant-picker-calendar-full .ant-picker-panel .ant-picker-calendar-date {
    height: 80px;
  }
  .ant-tabs > .ant-tabs-nav {
    background-color: ${palette("surfaceColor", 0)};
    padding: 0 20px;
    margin: 0;
  }
  .ant-tabs {
    height: 100%;
  }
  .ant-tabs-tabpane {
    overflow: auto;
    height: 100%;
  }
  .ant-tabs-content {
    height: 100%;
  }
  .ant-tabs-content-holder {
    overflow: auto;
  }
  .readOnly {
    .ant-input[disabled] {
      color: initial !important;
      background-color: initial !important;
    }
    .ant-select-disabled.ant-select-single:not(.ant-select-customize-input)
      .ant-select-selector {
      color: initial !important;
      background-color: initial !important;
    }
  }
  thead > tr > th {
    font-weight: 700;
  }
  .ant-select-single .ant-select-selector {
    color: initial !important;
  }
`;

export default AppWrapper;
